(function($) {
  // tabela-jc.js
  init($);

  // Recarrega os resultados quando o filtro é alterado e seta URL com parâmetros selecionados
  function set_url() {
    var base_url = window.location.pathname;
    var query = "";

    if (tipo_veiculo.length) {
      query += "?tipo_veiculo=" + encodeURIComponent(tipo_veiculo);
    }
    if (marca.length) {
      query += "&marca=" + encodeURIComponent(marca);
    }
    if (modelo.length) {
      query += "&modelo=" + encodeURIComponent(modelo);
    }
    if (ano.length) {
      query += "&ano=" + ano;
    }
    if (preco_min.length) {
      query += "&preco_min=" + preco_min.replace(/\./g, "");
    }
    if (preco_max.length) {
      query += "&preco_max=" + preco_max.replace(/\./g, "");
    }
    window.history.pushState("", "", base_url + query);
  }

  // Tipo de veículo
  $(".tipo_veiculo").click(function() {
    tipo_veiculo = $(this).children('input').val();
    marca = "";
    modelo = "";
    ano = "";

    get_opcoes_marca(tipo_veiculo);
    reset_field("#modelo", '<option value="">Modelo</option>', true);
    reset_field("#ano", '<option value="">Ano</option>', true);
    set_url();
  });

  // Marca
  $("#marca").change(function() {
    marca = $("#marca").val();
    modelo = "";
    ano = "";

    if (marca.length) {
      get_opcoes_modelo(tipo_veiculo, marca);
    } else {
      reset_field("#modelo", '<option value="">Modelo</option>', true);
    }

    reset_field("#ano", '<option value="">Ano</option>', true);
    set_url();
  });

  // Modelo
  $("#modelo").change(function() {
    modelo = $("#modelo").val();
    ano = "";

    if (modelo.length) {
      get_opcoes_ano(tipo_veiculo, marca, modelo);
    } else {
      reset_field("#ano", '<option value="">Ano</option>', true);
    }

    set_url();
  });

  $("#ano").change(function() {
    ano = $("#ano").val();
    set_url();
  });

  $("#preco_min").change(function() {
    preco_min = $("#preco_min").val();
    set_url();
  });

  $("#preco_max").change(function() {
    preco_max = $("#preco_max").val();
    set_url();
  });

  // Ignora campos vazios
  $('#form-tabela-jc').submit(function() {
    $("#form-tabela-jc input, #form-tabela-jc select").each(function() {
      if (!this.value) {
        $("#" + this.name).attr('disabled', true);
      }
      else if (this.name === 'preco_min' || this.name === 'preco_max') {
        this.value = this.value.replace(/\./g, "");
      }
    });
  });
})(jQuery);
